// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resumo{
    max-width: 600px;
    margin: auto;

}

.line-separator{
  height: 1px;
  background-color: #CCCCCC;
  width: 95%;
  margin: 0 auto;
}

.container-details{
  padding: 5px 20px;
}

.line-detail{
  display: grid;
  grid-template-columns: 0.3fr 0.7fr;
  -moz-column-gap: 20px;
       column-gap: 20px;
  font-size: 12px;
  color: var(--filter);
  font-weight: 400;
}

.question-detail{
  padding-left: 10px;

}

.answer-detail{
  padding-left: 10px;
}

.question-detail p,
.answer-detail p{
  margin: 0.5rem 0 0.5rem 0;
  color: var(--filter);
}

.filtros{
    max-width: 95%;
    margin: auto;
    margin-top: 10px;
    border-top: 1px solid #cccccc;
}

.super-poder{
    display: flex;
    flex-direction: row;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.06px;
    margin-top: 10px;
}

.super-poder p{
    margin-top: 5px;
    color: var(--filter);
}

.mr-super-poder-icon{
  transform: scale(0.8);
}

.mr-box-title-icon h3 {
    font-size: 20px;
    font-weight: 700;
}

.grid-container {
    padding-bottom: 110px;
}

.resumo-container {
    display: grid;
    grid-template-columns: 0.3fr 0.7fr;
    row-gap: 10px;
    -moz-column-gap: 20px;
         column-gap: 20px;
    justify-content: center;
    align-items: center;
    padding: 20px;
    color: var(--text);
}

.resumo-container * {
    margin: 0;
}

.resumo-container > p {
    font-size: 12px;
    padding-left: 10px;
}

.resumo-title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
}

.resumo-list-name {
    font-size: 16px;
    font-weight: 700;
}

.resumo-updated {
    font-size: 10px;
}

.resumo-image,
.resumo-property-key {
    grid-template-columns: 1 / 2;
}

.resumo-title,
.resumo-property-value {
    grid-template-columns: 2 / 3;
}

.resumo-image > img {
    max-width: 100%;
    border-radius: 8px;
}

.resumo-property-key::first-letter {
    text-transform: uppercase;
}

.resumo-property-value {
    text-transform: lowercase;
    font-weight: 700;
}
.mr-box-subtitle{
  display: flex !important;
  gap: 10px;
  padding: 15px;
  max-width: 95%;
}

.intervention-index-circle{
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-background);
}

.intervention-index-circle span{
  color: var(--primary-font);
  font-size: 12px;
}

.title-intervention{
  width: 90%;
  color: var(--text);
}

.gray-text {
    color: var(--text);
}

.list-save-modal {
    margin: 0 16px;
    height: 100%;
    transition: visibility .5s;
}

.list-save-modal #content {
    background-color: var(--form-background);
    padding: 0 20px 32px 16px;
}

#content label p {
    color: var(--text);
    font-size: 16px;
    font-weight: bold;
    margin: 0;
}

#content input {
    border-radius: 8px;
    border: 1px solid #5D5757;
    color: var(--text);
    background-color: var(--screen-background);
}

#content input::placeholder {
  color: var(--filter);
}

.list-save-modal-header {
    position: relative;
    background-color: var(--primary-background);
    border-radius: 20px 0px 0px 0px;
    width: 100%;
    height: 72px;
}

.list-save-modal-header p {
    text-align: center;
    color: var(--primary-font);
    bottom: 0;
    padding-top: 33px;
    font-weight: bold;
    font-size: 20px;
}

.list-save-modal-header button {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 8px;
    top: 4px;
}

.save-list-button {
    display: flex;
    justify-content: flex-end;
    margin: 0;
}

.save-list-button div {
    width: 160px;
    height: 40px;
}

.button-trocar{
  color: var(--text) !important;
  text-decoration: underline !important;
  cursor: pointer;
}

.button-disabled {
    background-color: var(--primary-button-disabled);
    color: var(--primary-font);

}

.comprar {
  width: auto;
  min-width: 86px;
  padding: 0 10px;
  white-space: nowrap;
}

.botao{
  cursor: pointer;
}

.boxSALVALISTA {
    justify-content: center;
}

.btn-salvar{
  width: 160px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 23px;
  background-color: var(--primary-background);
  color: var(--primary-font) !important;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 10px;
}


.mr-box-lista-valores-title{
  grid-area: header;
  border-bottom: 1px solid #cccccc;
}

.mr-box-lista-valores-title-pro{
  grid-area: header;
}

.mr-box-lista-valores-co2{
  grid-area: co2;
}

.mr-box-lista-valores-co2 p .co2-icon {
  width: 1.6rem;
}

::ng-deep .mr-box-lista-valores-co2 p .co2-icon .border,
::ng-deep .mr-box-lista-valores-co2 p .co2-icon .text {
  fill: var(--text);
}

::ng-deep .mr-box-lista-valores-co2 p .co2-icon .background {
  fill: transparent;
}


.mr-box-lista-valores-money{
  grid-area: money;
}

.mr-box-lista-valores-money p .wallet-icon {
  width: 1.4rem;
}

::ng-deep .mr-box-lista-valores-money p .wallet-icon .border,
::ng-deep .mr-box-lista-valores-money p .wallet-icon .text {
  color: var(--text);
}

::ng-deep .mr-box-lista-valores-money p .wallet-icon .background {
  color: transparent
}

.mr-box-lista-valores{
  width: 100%;
  max-width: 600px;
  height: 78%;
  grid-area: total;
  position: relative;
  padding-bottom: 20px;
  display: grid;
  gap: 5px;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
  "header header"
  "prod-left prod-right"
  "serv-left serv-right"
  "tot-left tot-right";
  align-items: center;
  color: var(--text);
}

.mr-box-lista-valores-pro-carbono{
  width: 100%;
  max-width: 600px;
  height: 78%;
  grid-area: total;
  position: relative;
  padding: 10px 0;
  display: grid;
  gap: 5px;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas:
  "header co2 money"
  "prod-left prod-center prod-right-pro"
  "serv-left serv-center serv-right-pro"
  "tot-left tot-center tot-right-pro";
  align-items: center;
  color: var(--text);
  border-top: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
}

.prod-left{
  grid-area: prod-left;
}

.serv-left{
  grid-area: serv-left;
}

.tot-left{
  grid-area: tot-left;
}

.prod-center{
  grid-area: prod-center;
  color: var(--secondary-font)
}

.serv-center{
  grid-area: serv-center;
  color: var(--secondary-font);
}

.tot-center{
  grid-area: tot-center;
  font-size: 12px !important;
  color: var(--secondary-font);
}

.prod-right{
  grid-area: prod-right;
}

.serv-right{
  grid-area: serv-right;
}

.tot-right{
  grid-area: tot-right;
  font-size: 12px !important;
}

.prod-right-pro{
  grid-area: prod-right-pro;
  color: var(--terciary-font);
}

.serv-right-pro{
  grid-area: serv-right-pro;
  color: var(--terciary-font);
}

.tot-right-pro{
  grid-area: tot-right-pro;
  font-size: 12px !important;
  color: var(--terciary-font);
}

.spinner-container {
  display: grid;
  justify-content: center;
}

@media (min-width: 768px) {
    .list-save-modal {
        margin: 0;
    }

    .list-save-modal #content {
        height: 100%;
    }

    .mr-box-save-lista {
        top: 0;
        max-width: 480px !important;
    }

    .save-list-button {
        position: fixed;
        bottom: 0;
        right: 0;
        margin: 0 20px 32px 0;
    }

}

@media screen and (min-width: 768px) {

  .resumo-image {
    width: 85%
  }

  .resumo-container {
    grid-template-columns: 1fr 0.3fr 0.7fr;
    grid-template-rows: auto auto;
    row-gap: 0;
  }

  .resumo-image {
    grid-column: 1 / 2;
    grid-row: 1 / 6;
  }

  .resumo-property-key {
    grid-column: 2 / 3;
  }

  .resumo-property-value {
    grid-column: 3 / 4;
  }

  .resumo-title {
    grid-column: 2 / 4;
  }
}

@media screen and (min-width: 1200px) {

  .resumo{
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    max-width: none;
    width: 100%;
  }

  .resumo p{
    width: 50%;
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    padding: 10px;
  }

  .resumo > p:nth-child(n+4){
    border-top: 1px solid #CCCCCC;
  }

  .line-separator{
    width: 100%;
  }

  .container-resumo{
    width: 100%;
  }

  .detalhamentos-container{
    grid-area: details;
    display: flex;
    width: 100%;
  }

  .details{
    line-height: 5px;
  }

  .filtros{
    max-width: none;
    margin: auto;
  }

  .grid-container{
    display: grid;
    width: 70%;
    border-top: 1px solid #CCCCCC;
    max-width: 1200px;
    margin: 0 auto;
    padding: 15px 0 110px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
      "header  header  total"
      "details details details"
      "main    main    main"
    ;
  }

  .resumo-container{
    grid-area: header;
    padding: 0 0 20px 0;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .container-filtros{
    width: 53%;
  }

  .mr-box-subtitle{
    max-width: none;
    border-bottom: 1px solid #CCCCCC;
    padding: 10px 30px;
    align-items: center;
  }

  .title-intervention{
    width: 90%;
    min-height: 45px;
    display: flex;
    align-items: center;
  }

  .container-itens{
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .container-itens > div{
    width: 100%;
  }

  .container-itens-1,
  .container-itens-2,
  .container-itens-3{
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 510px;
  }

  .container-itens-1 > div{
    width: 100%;
  }

  .container-itens-2 > div{
    width: 50%;
  }

  .container-itens-2 .linha,
  .container-itens-3 .linha{
    min-height: 155px;
  }

  .container-itens-3 > div{
    width: 33%;
  }

  .mr-box-lista-item{
    width: 85%;
  }

  .mr-box-lista-valores{
    border-top: none !important;
    width: 100%;
    height: 78%;
    grid-area: total;
    position: relative;
    padding-bottom: 20px;
    display: grid;
    gap: 5px;
    grid-template-columns: 1.3fr 0.7fr;
    grid-template-areas:
    "header header"
    "prod-left prod-right"
    "serv-left serv-right"
    "tot-left tot-right";
    align-items: center;
  }

  .mr-box-lista-valores-pro-carbono{
    border-top: none !important;
    width: 100%;
    height: 78%;
    grid-area: total;
    position: relative;
    padding: 0;
    display: grid;
    gap: 5px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
    "header co2 money"
    "prod-left prod-center prod-right-pro"
    "serv-left serv-center serv-right-pro"
    "tot-left tot-center tot-right-pro";
    align-items: center;
    border: none;
  }

  .line-left-container{
    position: absolute;
    left: 0;
    bottom: 10%;
    height: 80%;
    width: 2px;
    background-color: var(--form-background);
  }

  .mr-box-lista-valores-title{
    border-bottom: none !important;
    grid-area: header;
  }

  .grid-interventions-1{
    grid-area: main;
    width: 100%;
    margin: 0 auto;
    display: flex;
  }

  .grid-interventions-1 >
  .interventions-container {
    width: 100%;
  }

  .grid-interventions-2{
    grid-area: main;
    width: 100%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "col1 col2"
    ;

  }

  .grid-interventions-3{
    grid-area: main;
    width: 100%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
      "col1 col2 col3"
    ;

  }

  .mr-box-lista-item .linha{
    border-top: none !important;
    border-bottom: 1px solid #CCCCCC !important;
  }
}

.pro-carbono {
  color: var(--terciary-pro-carbono-font)
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/my-list/my-list.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,qBAAgB;OAAhB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,aAAa;IACb,qBAAgB;SAAhB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;EACE,wBAAwB;EACxB,SAAS;EACT,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,+BAA+B;IAC/B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,eAAe;AACjB;;AAEA;IACI,gDAAgD;IAChD,0BAA0B;;AAE9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B;;;;sBAIoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,QAAQ;EACR,kCAAkC;EAClC;;;;qCAImC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,MAAM;QACN,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,SAAS;QACT,QAAQ;QACR,qBAAqB;IACzB;;AAEJ;;AAEA;;EAEE;IACE;EACF;;EAEA;IACE,sCAAsC;IACtC,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,eAAe;IACf,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,UAAU;IACV,6BAA6B;IAC7B,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,kCAAkC;IAClC;;;;IAIA;EACF;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kCAAkC;EACpC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,QAAQ;IACR,kCAAkC;IAClC;;;;wBAIoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,QAAQ;IACR,kCAAkC;IAClC;;;;uCAImC;IACnC,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,WAAW;IACX,UAAU;IACV,wCAAwC;EAC1C;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B;;IAEA;;EAEF;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;IACd,aAAa;IACb,kCAAkC;IAClC;;IAEA;;EAEF;;EAEA;IACE,2BAA2B;IAC3B,2CAA2C;EAC7C;AACF;;AAEA;EACE;AACF","sourcesContent":[".resumo{\n    max-width: 600px;\n    margin: auto;\n\n}\n\n.line-separator{\n  height: 1px;\n  background-color: #CCCCCC;\n  width: 95%;\n  margin: 0 auto;\n}\n\n.container-details{\n  padding: 5px 20px;\n}\n\n.line-detail{\n  display: grid;\n  grid-template-columns: 0.3fr 0.7fr;\n  column-gap: 20px;\n  font-size: 12px;\n  color: var(--filter);\n  font-weight: 400;\n}\n\n.question-detail{\n  padding-left: 10px;\n\n}\n\n.answer-detail{\n  padding-left: 10px;\n}\n\n.question-detail p,\n.answer-detail p{\n  margin: 0.5rem 0 0.5rem 0;\n  color: var(--filter);\n}\n\n.filtros{\n    max-width: 95%;\n    margin: auto;\n    margin-top: 10px;\n    border-top: 1px solid #cccccc;\n}\n\n.super-poder{\n    display: flex;\n    flex-direction: row;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14.06px;\n    margin-top: 10px;\n}\n\n.super-poder p{\n    margin-top: 5px;\n    color: var(--filter);\n}\n\n.mr-super-poder-icon{\n  transform: scale(0.8);\n}\n\n.mr-box-title-icon h3 {\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.grid-container {\n    padding-bottom: 110px;\n}\n\n.resumo-container {\n    display: grid;\n    grid-template-columns: 0.3fr 0.7fr;\n    row-gap: 10px;\n    column-gap: 20px;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    color: var(--text);\n}\n\n.resumo-container * {\n    margin: 0;\n}\n\n.resumo-container > p {\n    font-size: 12px;\n    padding-left: 10px;\n}\n\n.resumo-title {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 10px;\n}\n\n.resumo-list-name {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.resumo-updated {\n    font-size: 10px;\n}\n\n.resumo-image,\n.resumo-property-key {\n    grid-template-columns: 1 / 2;\n}\n\n.resumo-title,\n.resumo-property-value {\n    grid-template-columns: 2 / 3;\n}\n\n.resumo-image > img {\n    max-width: 100%;\n    border-radius: 8px;\n}\n\n.resumo-property-key::first-letter {\n    text-transform: uppercase;\n}\n\n.resumo-property-value {\n    text-transform: lowercase;\n    font-weight: 700;\n}\n.mr-box-subtitle{\n  display: flex !important;\n  gap: 10px;\n  padding: 15px;\n  max-width: 95%;\n}\n\n.intervention-index-circle{\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--primary-background);\n}\n\n.intervention-index-circle span{\n  color: var(--primary-font);\n  font-size: 12px;\n}\n\n.title-intervention{\n  width: 90%;\n  color: var(--text);\n}\n\n.gray-text {\n    color: var(--text);\n}\n\n.list-save-modal {\n    margin: 0 16px;\n    height: 100%;\n    transition: visibility .5s;\n}\n\n.list-save-modal #content {\n    background-color: var(--form-background);\n    padding: 0 20px 32px 16px;\n}\n\n#content label p {\n    color: var(--text);\n    font-size: 16px;\n    font-weight: bold;\n    margin: 0;\n}\n\n#content input {\n    border-radius: 8px;\n    border: 1px solid #5D5757;\n    color: var(--text);\n    background-color: var(--screen-background);\n}\n\n#content input::placeholder {\n  color: var(--filter);\n}\n\n.list-save-modal-header {\n    position: relative;\n    background-color: var(--primary-background);\n    border-radius: 20px 0px 0px 0px;\n    width: 100%;\n    height: 72px;\n}\n\n.list-save-modal-header p {\n    text-align: center;\n    color: var(--primary-font);\n    bottom: 0;\n    padding-top: 33px;\n    font-weight: bold;\n    font-size: 20px;\n}\n\n.list-save-modal-header button {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    right: 8px;\n    top: 4px;\n}\n\n.save-list-button {\n    display: flex;\n    justify-content: flex-end;\n    margin: 0;\n}\n\n.save-list-button div {\n    width: 160px;\n    height: 40px;\n}\n\n.button-trocar{\n  color: var(--text) !important;\n  text-decoration: underline !important;\n  cursor: pointer;\n}\n\n.button-disabled {\n    background-color: var(--primary-button-disabled);\n    color: var(--primary-font);\n\n}\n\n.comprar {\n  width: auto;\n  min-width: 86px;\n  padding: 0 10px;\n  white-space: nowrap;\n}\n\n.botao{\n  cursor: pointer;\n}\n\n.boxSALVALISTA {\n    justify-content: center;\n}\n\n.btn-salvar{\n  width: 160px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 23px;\n  background-color: var(--primary-background);\n  color: var(--primary-font) !important;\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n}\n\n\n.mr-box-lista-valores-title{\n  grid-area: header;\n  border-bottom: 1px solid #cccccc;\n}\n\n.mr-box-lista-valores-title-pro{\n  grid-area: header;\n}\n\n.mr-box-lista-valores-co2{\n  grid-area: co2;\n}\n\n.mr-box-lista-valores-co2 p .co2-icon {\n  width: 1.6rem;\n}\n\n::ng-deep .mr-box-lista-valores-co2 p .co2-icon .border,\n::ng-deep .mr-box-lista-valores-co2 p .co2-icon .text {\n  fill: var(--text);\n}\n\n::ng-deep .mr-box-lista-valores-co2 p .co2-icon .background {\n  fill: transparent;\n}\n\n\n.mr-box-lista-valores-money{\n  grid-area: money;\n}\n\n.mr-box-lista-valores-money p .wallet-icon {\n  width: 1.4rem;\n}\n\n::ng-deep .mr-box-lista-valores-money p .wallet-icon .border,\n::ng-deep .mr-box-lista-valores-money p .wallet-icon .text {\n  color: var(--text);\n}\n\n::ng-deep .mr-box-lista-valores-money p .wallet-icon .background {\n  color: transparent\n}\n\n.mr-box-lista-valores{\n  width: 100%;\n  max-width: 600px;\n  height: 78%;\n  grid-area: total;\n  position: relative;\n  padding-bottom: 20px;\n  display: grid;\n  gap: 5px;\n  grid-template-columns: 1fr 1fr;\n  grid-template-areas:\n  \"header header\"\n  \"prod-left prod-right\"\n  \"serv-left serv-right\"\n  \"tot-left tot-right\";\n  align-items: center;\n  color: var(--text);\n}\n\n.mr-box-lista-valores-pro-carbono{\n  width: 100%;\n  max-width: 600px;\n  height: 78%;\n  grid-area: total;\n  position: relative;\n  padding: 10px 0;\n  display: grid;\n  gap: 5px;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-areas:\n  \"header co2 money\"\n  \"prod-left prod-center prod-right-pro\"\n  \"serv-left serv-center serv-right-pro\"\n  \"tot-left tot-center tot-right-pro\";\n  align-items: center;\n  color: var(--text);\n  border-top: 1px solid #cccccc;\n  border-bottom: 1px solid #cccccc;\n}\n\n.prod-left{\n  grid-area: prod-left;\n}\n\n.serv-left{\n  grid-area: serv-left;\n}\n\n.tot-left{\n  grid-area: tot-left;\n}\n\n.prod-center{\n  grid-area: prod-center;\n  color: var(--secondary-font)\n}\n\n.serv-center{\n  grid-area: serv-center;\n  color: var(--secondary-font);\n}\n\n.tot-center{\n  grid-area: tot-center;\n  font-size: 12px !important;\n  color: var(--secondary-font);\n}\n\n.prod-right{\n  grid-area: prod-right;\n}\n\n.serv-right{\n  grid-area: serv-right;\n}\n\n.tot-right{\n  grid-area: tot-right;\n  font-size: 12px !important;\n}\n\n.prod-right-pro{\n  grid-area: prod-right-pro;\n  color: var(--terciary-font);\n}\n\n.serv-right-pro{\n  grid-area: serv-right-pro;\n  color: var(--terciary-font);\n}\n\n.tot-right-pro{\n  grid-area: tot-right-pro;\n  font-size: 12px !important;\n  color: var(--terciary-font);\n}\n\n.spinner-container {\n  display: grid;\n  justify-content: center;\n}\n\n@media (min-width: 768px) {\n    .list-save-modal {\n        margin: 0;\n    }\n\n    .list-save-modal #content {\n        height: 100%;\n    }\n\n    .mr-box-save-lista {\n        top: 0;\n        max-width: 480px !important;\n    }\n\n    .save-list-button {\n        position: fixed;\n        bottom: 0;\n        right: 0;\n        margin: 0 20px 32px 0;\n    }\n\n}\n\n@media screen and (min-width: 768px) {\n\n  .resumo-image {\n    width: 85%\n  }\n\n  .resumo-container {\n    grid-template-columns: 1fr 0.3fr 0.7fr;\n    grid-template-rows: auto auto;\n    row-gap: 0;\n  }\n\n  .resumo-image {\n    grid-column: 1 / 2;\n    grid-row: 1 / 6;\n  }\n\n  .resumo-property-key {\n    grid-column: 2 / 3;\n  }\n\n  .resumo-property-value {\n    grid-column: 3 / 4;\n  }\n\n  .resumo-title {\n    grid-column: 2 / 4;\n  }\n}\n\n@media screen and (min-width: 1200px) {\n\n  .resumo{\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0;\n    max-width: none;\n    width: 100%;\n  }\n\n  .resumo p{\n    width: 50%;\n    font-size: 12px;\n    font-weight: 400;\n    margin: 0;\n    padding: 10px;\n  }\n\n  .resumo > p:nth-child(n+4){\n    border-top: 1px solid #CCCCCC;\n  }\n\n  .line-separator{\n    width: 100%;\n  }\n\n  .container-resumo{\n    width: 100%;\n  }\n\n  .detalhamentos-container{\n    grid-area: details;\n    display: flex;\n    width: 100%;\n  }\n\n  .details{\n    line-height: 5px;\n  }\n\n  .filtros{\n    max-width: none;\n    margin: auto;\n  }\n\n  .grid-container{\n    display: grid;\n    width: 70%;\n    border-top: 1px solid #CCCCCC;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 15px 0 110px;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-areas:\n      \"header  header  total\"\n      \"details details details\"\n      \"main    main    main\"\n    ;\n  }\n\n  .resumo-container{\n    grid-area: header;\n    padding: 0 0 20px 0;\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n\n  .container-filtros{\n    width: 53%;\n  }\n\n  .mr-box-subtitle{\n    max-width: none;\n    border-bottom: 1px solid #CCCCCC;\n    padding: 10px 30px;\n    align-items: center;\n  }\n\n  .title-intervention{\n    width: 90%;\n    min-height: 45px;\n    display: flex;\n    align-items: center;\n  }\n\n  .container-itens{\n    padding: 0 10px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n  }\n\n  .container-itens > div{\n    width: 100%;\n  }\n\n  .container-itens-1,\n  .container-itens-2,\n  .container-itens-3{\n    padding: 0 10px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    height: 510px;\n  }\n\n  .container-itens-1 > div{\n    width: 100%;\n  }\n\n  .container-itens-2 > div{\n    width: 50%;\n  }\n\n  .container-itens-2 .linha,\n  .container-itens-3 .linha{\n    min-height: 155px;\n  }\n\n  .container-itens-3 > div{\n    width: 33%;\n  }\n\n  .mr-box-lista-item{\n    width: 85%;\n  }\n\n  .mr-box-lista-valores{\n    border-top: none !important;\n    width: 100%;\n    height: 78%;\n    grid-area: total;\n    position: relative;\n    padding-bottom: 20px;\n    display: grid;\n    gap: 5px;\n    grid-template-columns: 1.3fr 0.7fr;\n    grid-template-areas:\n    \"header header\"\n    \"prod-left prod-right\"\n    \"serv-left serv-right\"\n    \"tot-left tot-right\";\n    align-items: center;\n  }\n\n  .mr-box-lista-valores-pro-carbono{\n    border-top: none !important;\n    width: 100%;\n    height: 78%;\n    grid-area: total;\n    position: relative;\n    padding: 0;\n    display: grid;\n    gap: 5px;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-areas:\n    \"header co2 money\"\n    \"prod-left prod-center prod-right-pro\"\n    \"serv-left serv-center serv-right-pro\"\n    \"tot-left tot-center tot-right-pro\";\n    align-items: center;\n    border: none;\n  }\n\n  .line-left-container{\n    position: absolute;\n    left: 0;\n    bottom: 10%;\n    height: 80%;\n    width: 2px;\n    background-color: var(--form-background);\n  }\n\n  .mr-box-lista-valores-title{\n    border-bottom: none !important;\n    grid-area: header;\n  }\n\n  .grid-interventions-1{\n    grid-area: main;\n    width: 100%;\n    margin: 0 auto;\n    display: flex;\n  }\n\n  .grid-interventions-1 >\n  .interventions-container {\n    width: 100%;\n  }\n\n  .grid-interventions-2{\n    grid-area: main;\n    width: 100%;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-template-areas:\n      \"col1 col2\"\n    ;\n\n  }\n\n  .grid-interventions-3{\n    grid-area: main;\n    width: 100%;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-areas:\n      \"col1 col2 col3\"\n    ;\n\n  }\n\n  .mr-box-lista-item .linha{\n    border-top: none !important;\n    border-bottom: 1px solid #CCCCCC !important;\n  }\n}\n\n.pro-carbono {\n  color: var(--terciary-pro-carbono-font)\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
